import type { FunctionComponent, SVGProps } from 'react';

import { InfoIcon, WarningIcon } from '@setup/svg-icons/svg-icons';
import theme from '@setup/theme/theme';

type NotificationState = {
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  iconColor?: string;
};

type NotificationVariantConfig = {
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  defaultState: NotificationState;
  hoverState: NotificationState;
  activeState: NotificationState;
};

type NotificationVariantConfigMap = {
  [key in 'info' | 'warning']: NotificationVariantConfig;
};
export const notificationVariantConfig: NotificationVariantConfigMap = {
  info: {
    icon: InfoIcon,
    defaultState: {
      color: theme.palette.case.blue.b700,
      backgroundColor: theme.palette.case.blue.b100,
      borderColor: theme.palette.case.blue.b200,
      iconColor: theme.palette.case.blue.b600,
    },
    hoverState: {
      backgroundColor: theme.palette.case.blue.b200,
      borderColor: theme.palette.case.blue.b300,
    },
    activeState: {
      borderColor: theme.palette.case.blue.b500,
    },
  },
  warning: {
    icon: WarningIcon,
    defaultState: {
      color: theme.palette.case.orange.o700,
      backgroundColor: theme.palette.case.orange.o100,
      borderColor: theme.palette.case.orange.o200,
      iconColor: theme.palette.case.orange.o600,
    },
    hoverState: {
      backgroundColor: theme.palette.case.orange.o200,
      borderColor: theme.palette.case.orange.o300,
    },
    activeState: {
      borderColor: theme.palette.case.orange.o500,
    },
  },
};
